//libraries
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { FC, useEffect, useRef, useState } from 'react'
import { useIntersection } from 'react-use'

import FooterCopyright from '@/components/FooterCopyright'
import FooterLogo from '@/components/FooterLogo'
import FooterMenu from '@/components/FooterMenu/FooterMenu'
import { routes, footerMenu } from '@/config'

import DefaultComponentProps from '@/types/DefaultComponentProps'

import styles from './Footer.module.scss'

export const Footer: FC<DefaultComponentProps> = ({ className = '' }) => {
  const { t } = useTranslation('footer')

  const intersectionRef = useRef(null)
  const [isAnimated, setAnimated] = useState(false)

  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.4
  })

  useEffect(() => {
    if (intersection?.isIntersecting) {
      setAnimated(true)
    }
  }, [intersection?.isIntersecting])

  return (
    <footer
      ref={intersectionRef}
      className={clsx(styles['footer'], className, {
        [styles['footer_animation-start']]: isAnimated
      })}
    >
      <div className={styles['footer__content']}>
        <div className={styles['footer__col']}>
          <FooterLogo className={styles['footer__logo']} />
          <FooterCopyright />
        </div>
        {footerMenu.map((section) => (
          <div
            key={section.id}
            className={clsx(styles['footer__col'], {
              [styles['footer__col_social']]: section.id === 'social'
            })}
          >
            <FooterMenu
              heading={t(`menu.${section.id}.heading`)}
              items={section.items.map((item) => ({
                id: item.id,
                label: t(`menu.${section.id}.items.${item.id}`),
                href: routes[item.id.toUpperCase()],
                external: item.external
              }))}
              className={styles['footer__menu']}
            />
            {section.id === 'social' && (
              <div className={styles['footer__payments']}>
                <span className={styles['footer__payment']}>
                  <img
                    src="/images/payments/visa.svg"
                    alt="Visa"
                    width={74.5116}
                    height={24}
                  />
                </span>
                <span className={styles['footer__payment']}>
                  <img
                    src="/images/payments/mastercard.svg"
                    alt="Mastercard"
                    width={38.8249}
                    height={24}
                  />
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </footer>
  )
}
